import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Seller, SellersService } from 'src/app/core/sellers.service';
import { DialogService } from 'src/app/core/dialog.service';
import { SellersAccessControlDialogComponent } from 'src/app/sellers/sellers-access-control-dialog/sellers-access-control-dialog.component';
import { SellersConfirmOtpDialogComponent } from 'src/app/sellers/sellers-confirm-otp-dialog/sellers-confirm-otp-dialog.component';
import { SellersEditDialogComponent } from 'src/app/sellers/sellers-edit-dialog/sellers-edit-dialog.component';
import { SellersSetMfaDialogComponent } from 'src/app/sellers/sellers-set-mfa-dialog/sellers-set-mfa-dialog.component';
import { SellersStoresDialogComponent } from 'src/app/sellers/sellers-stores-dialog/sellers-stores-dialog.component';

@Component({
  selector: 'app-seller-details-header',
  templateUrl: './seller-details-header.component.html',
  styleUrls: ['./seller-details-header.component.scss'],
})
export class SellerDetailsHeaderComponent {
  @Input() seller_id?: string | null;

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  seller?: Seller;
  is_read_running = false;

  constructor(
    private utils_service: UtilsService,
    private navigation_service: NavigationService,
    private sellers_service: SellersService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {}

  ngOnInit(): void {
    this.readSeller(this.seller_id as string);
  }

  onBackClick(): void {
    this.navigation_service.toSellers();
  }

  readSeller(seller_id: string): void {
    this.is_read_running = true;
    this.sellers_service.readSeller(seller_id).subscribe({
      next: response => {
        this.seller = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.seller_id || '-');
  }

  onEditClick(): void {
    this.dialog_service
      .openDialog(SellersEditDialogComponent, { seller: this.seller })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onStoresClick(): void {
    if (this.seller) this.dialog_service.openDialog(SellersStoresDialogComponent, { seller_id: this.seller.seller_id });
  }

  onSetMfaClick(): void {
    this.dialog_service
      .openDialog(SellersSetMfaDialogComponent, { seller: this.seller })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onUnlockSellerClick() {
    this.dialog_service
      .openDialog(SellersAccessControlDialogComponent, {
        seller: this.seller,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }

        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  onInfoClick(): void {
    this.dialog_service.openDialog(SellersConfirmOtpDialogComponent, {
      seller: this.seller,
    });
  }
}
